import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import logoIcon from '../../assets/logo-icon.svg';

export const AuthGuard = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-100">
        <div className="animate-pulse">
          <img src={logoIcon} alt="Logo" className="w-32 h-32 animate-grow-shrink" />
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : null;
};